const SPECIFIC_MOVEABLE_CRM_STATES = [
  "a0_match",
  "a0_invalid_email",
  "a0_fixed_email",
  "a4_documents_request_sent",
  "a4_documents_reminder1",
  "a4_documents_reminder2",
  "a4_documents_reminder3",
  "a4_documents_call_reminder1",
  "a4_documents_call_reminder2",
  "a4_checking_pax_attachments"
];

const GENERAL_MOVEABLE_CRM_STATES = ["a1", "a2", "a3"];

const isDestinationClaimCrmStateHigherOrEqual = (
  claimCrmState,
  paxCrmState,
  allClaimStates
) => {
  if (allClaimStates) {
    return (
      allClaimStates.indexOf(claimCrmState) >=
      allClaimStates.indexOf(paxCrmState)
    );
  }
  return false
};

export const isCrmStateMoveable = crmState => !!crmState && (
  GENERAL_MOVEABLE_CRM_STATES.includes(crmState.substr(0, 2)) ||
  SPECIFIC_MOVEABLE_CRM_STATES.includes(crmState)
);

export const isPassengerMoveable = (
  claimCrmState,
  paxCrmState,
  allClaimStates
) =>
  isCrmStateMoveable(paxCrmState) &&
  isDestinationClaimCrmStateHigherOrEqual(
    claimCrmState,
    paxCrmState,
    allClaimStates
  );



// WEBPACK FOOTER //
// ./src/utils/passengersMoveableCrmStates.js